import {
  canSendApplicationForFinalReview,
  isApplicationCommissionClosed,
  isApplicationCommissionCompleted,
  isApplicationDiscontinued,
  isApplicationFinalReviewPending,
} from "./commissionsConstants";

/**
 * @param {object} application
 * @param {string} actionId
 * @param {{ activeReport?: string, commissionView?: string }} context
 */
export function isRowEligibleForBulkAction(
  application,
  actionId,
  { activeReport = "commission", commissionView = "active" } = {},
) {
  const isCommissionTab = activeReport === "commission";
  if (!isCommissionTab) {
    return false;
  }

  const isFinalReviewView = commissionView === "final_review";
  const isCompletedView = commissionView === "completed";
  const isExceptionsReconciliationView =
    commissionView === "exceptions_reconciliation";
  const alreadyDiscontinued = isApplicationDiscontinued(application);
  const alreadyCompleted = isApplicationCommissionCompleted(application);
  const isClosed = isApplicationCommissionClosed(application);
  const isPendingFinalReview = isApplicationFinalReviewPending(application);
  const alreadyCommissionable = Boolean(application?.is_commissionable);
  const queueId = application?.queue_id;

  switch (actionId) {
    case "mark_completed":
      return (
        !isFinalReviewView &&
        !isCompletedView &&
        !isExceptionsReconciliationView &&
        !isPendingFinalReview &&
        alreadyCommissionable &&
        !alreadyCompleted &&
        !isClosed
      );
    case "discontinue":
      return (
        application?.category === "education" &&
        !alreadyDiscontinued &&
        commissionView === "active" &&
        !isClosed
      );
    case "reactivate":
      return (
        application?.category === "education" &&
        alreadyDiscontinued &&
        (commissionView === "active" ||
          commissionView === "exceptions_reconciliation" ||
          commissionView === "all") &&
        !isClosed
      );
    case "revert_completed":
      return (
        isCompletedView &&
        alreadyCompleted &&
        !isPendingFinalReview &&
        !isClosed
      );
    case "submit_final_review":
      return (
        !isPendingFinalReview &&
        (isCompletedView || isExceptionsReconciliationView) &&
        canSendApplicationForFinalReview(application) &&
        !isClosed
      );
    case "approve_final_review":
      return isFinalReviewView && isPendingFinalReview && !isClosed;
    case "return_final_review":
      return isFinalReviewView && isPendingFinalReview && !isClosed;
    case "remove_from_commissionable":
      return Boolean(queueId) && !isClosed;
    default:
      return false;
  }
}

export function filterApplicationsEligibleForBulkAction(
  applications,
  actionId,
  context,
) {
  return (applications || []).filter((application) =>
    isRowEligibleForBulkAction(application, actionId, context),
  );
}
